"use strict";
import { createSmartAccountClient } from "permissionless";
import { createPublicClient, custom, http } from "viem";
import { bsc } from "viem/chains";
const BUNDLER_URL = process.env.REACT_APP_SCW_BUNDLER_URL?.trim();
export function createSelfFundedScwSender({
  account,
  readProvider,
  expectedAddress
}) {
  if (!BUNDLER_URL || !account?.address) {
    return null;
  }
  if (expectedAddress && account.address.toLowerCase() !== expectedAddress.toLowerCase()) {
    console.warn("Topaz ID self-funded fallback unavailable: account address does not match the smart wallet.");
    return null;
  }
  const publicClient = createPublicClient({ chain: bsc, transport: custom(readProvider) });
  const smartAccountClient = createSmartAccountClient({
    account,
    chain: bsc,
    client: publicClient,
    bundlerTransport: http(BUNDLER_URL)
  });
  return {
    sendTransaction: (call) => smartAccountClient.sendTransaction({ to: call.to, value: call.value, data: call.data }),
    sendCalls: async (calls) => {
      const hash = await smartAccountClient.sendUserOperation({ calls });
      const receipt = await smartAccountClient.waitForUserOperationReceipt({ hash });
      return receipt.receipt.transactionHash;
    }
  };
}
